export const EVENT_NAME = {
  CALENDAR_TAB_SELECTED: 'Calendar Tab Selected'
}

export const ORDER_STATUS = {
  SHIPPED: 'shipped'
}

export const PAGE_NAMES = {
  PRODUCT_LIST: 'Home Product List',
  MENU: 'Menu / Product Selection',
  ORDERS: 'Orders'
}

export const TAB_RATING_STATUS = {
  RATES_AVAILABLE: 'Rates available',
  NO_RATES_AVAILABLE: 'No Rates available'
}
